import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

Bugsnag.start({
    apiKey: 'af9add6acf3e99e1a59db86e69afe0ff',
    plugins: [new BugsnagPluginReact()]
});
export default Bugsnag;
